import sortable from 'html5sortable/dist/html5sortable.es.js';
import app from 'flarum/app';
import Button from 'flarum/components/Button';
import cleanFieldConfiguration from '../cleanFieldConfiguration';
import typeMap from './typeMap';

/* global m */

export default class FieldList {
    constructor({
                    configs = [],
                    submission = {},
                    uploader = null,
                    onchange = () => {
                    },
                    disabled = false,
                    validationErrors = {},
                    depth = 0,
                    expertMode = false,
                }) {
        this.configs = configs;
        this.submission = submission;
        this.uploader = uploader;
        this.onchange = onchange;
        this.disabled = disabled;
        this.validationErrors = validationErrors;
        this.depth = depth;
        this.expertMode = expertMode;
    }

    configureView() {
        return [
            m('div', {
                config: element => {
                    //TODO: disable handles when this.disabled
                    sortable(element, {
                        handle: '.js-handle',
                        placeholderClass: 'FormulaireSortablePlaceholder',
                    })[0].addEventListener('sortupdate', e => {
                        this.configs.splice(e.detail.destination.index, 0, this.configs.splice(e.detail.origin.index, 1)[0]);
                        this.onchange();
                        m.redraw.strategy('all'); // Force a full redraw, so that the config method of html5sortable is called again
                        m.redraw();
                    });
                },
            }, this.configs.map((config, index) => {
                const field = new typeMap[config.type]({
                    config,
                    uploader: this.uploader,
                    onchange: () => {
                        this.onchange();
                    },
                    onduplicate: () => {
                        this.configs.splice(index + 1, 0, JSON.parse(JSON.stringify(config)));
                        cleanFieldConfiguration(this.configs[index + 1], true);
                        this.onchange();
                    },
                    ondelete: () => {
                        this.configs.splice(index, 1);
                        this.onchange();
                    },
                    disabled: this.disabled,
                    validationErrors: this.validationErrors,
                    depth: this.depth,
                    expertMode: this.expertMode,
                });

                return field.configureView();
            })),
            Button.component({
                className: 'Button Button--block',
                onclick: () => {
                    this.configs.push({
                        type: 'short',
                    });
                    this.onchange();
                    m.redraw.strategy('all'); // Force a full redraw, so that the config method of html5sortable is called again
                },
                disabled: this.disabled,
            }, app.translator.trans('kilowhat-formulaire.forum.template-editor.add-field')),
        ];
    }

    listView(display = false) {
        return [
            this.configs.map(config => {
                const field = new typeMap[config.type]({
                    config,
                    submission: this.submission,
                    uploader: this.uploader,
                    onchange: () => {
                        this.onchange();
                    },
                    disabled: this.disabled,
                    validationErrors: this.validationErrors,
                    depth: this.depth,
                });

                return display ? field.displayView() : field.fillView();
            }),
        ];
    }
}
